<template>
    <div class="op-empty">
        <v-icon>mdi-inbox-outline</v-icon>
        <span>{{ text }}</span>
    </div>
</template>

<script>
export default {
    name: "OtherProceedingEmpty",
    props: { text: { type: String, required: true } },
};
</script>
